import { UserCheck, KeyRound, CheckCircle, Settings, Activity, Download } from "lucide-react";
import { motion } from "motion/react";

export function OnboardingSteps() {
  const steps = [
    {
      icon: UserCheck,
      title: "Enter Consumer No",
      description: "Provide your electricity consumer number"
    },
    {
      icon: KeyRound,
      title: "OTP Verification",
      description: "Verify your identity with OTP"
    },
    {
      icon: CheckCircle,
      title: "Easy Green Energy Tariff Opt in",
      description: "Simple opt in for green energy tariff"
    },
    {
      icon: Settings,
      title: "Customizable Green Energy Requisition",
      description: "Configure your green energy requirements"
    },
    {
      icon: Activity,
      title: "Monitoring",
      description: "Track your green energy consumption"
    },
    {
      icon: Download,
      title: "Auditable GEC Certificate Download",
      description: "Get your verified GEC certificate"
    }
  ];

  return (
    <section id="onboarding" className="py-16 md:py-24 bg-gradient-to-br from-emerald-50 to-cyan-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl mb-4 bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">
            Easy Onboarding
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Get started with green energy in just 6 simple steps
          </p>
        </motion.div>

        {/* Steps Timeline */}
        <div className="max-w-5xl mx-auto mb-12">
          <div className="relative">
            {/* Connection Line - Desktop */}
            <div className="hidden md:block absolute top-8 left-0 right-0 h-0.5 bg-gradient-to-r from-emerald-300 via-cyan-300 to-emerald-300"></div>

            <div className="grid md:grid-cols-6 gap-8 md:gap-4 relative">
              {steps.map((step, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="flex flex-col items-center text-center"
                >
                  {/* Icon Circle */}
                  <div className="relative z-10 w-16 h-16 bg-gradient-to-br from-emerald-500 to-cyan-500 rounded-full flex items-center justify-center mb-4 shadow-lg">
                    <step.icon className="w-8 h-8 text-white" />
                  </div>

                  {/* Step Number */}
                  <div className="absolute top-0 right-0 md:relative md:top-auto md:right-auto w-6 h-6 bg-white border-2 border-emerald-500 rounded-full flex items-center justify-center text-xs -mt-2">
                    {index + 1}
                  </div>

                  {/* Content */}
                  <h3 className="text-sm mb-2 text-gray-900">
                    {step.title}
                  </h3>
                  <p className="text-xs text-gray-600">
                    {step.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>

        {/* Pricing Info */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="max-w-2xl mx-auto"
        >
          <div className="bg-white p-8 rounded-2xl shadow-lg border border-emerald-100">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex-1">
                <p className="text-gray-600 mb-2">Green Tariff Rate</p>
                <p className="text-4xl bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">
                  ₹0.75 <span className="text-lg">per unit</span>
                </p>
                <p className="text-sm text-gray-500 mt-1">(PGVCL approved rate)</p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  // href={`${import.meta.env.VITE_API_URL}/auth/login`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-3 bg-gradient-to-r from-emerald-500 to-cyan-500 text-white rounded-lg hover:shadow-xl transition-shadow inline-block text-center"
                >
                  Get Started Now
                </a>

              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
